export default __webpack_public_path__ + "static/media/concluido.9c214970.svg";